import Model, { attr } from '@ember-data/model';

// This model contains all the information needed to upload a file to AWS S3 bucket
export default class FileUploadInfoModel extends Model {
  @attr('string') key!: string;
  @attr('string') bucket!: string;
  @attr('string') accessKey!: string;
  @attr('string') policy!: string;
  @attr('string') signature!: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'file-upload-info': FileUploadInfoModel;
  }
}
